import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { FacialRecognition } from './models/facial-recognition.model';


export interface FacialRecognitionState extends EntityState<FacialRecognition> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'FacialRecognition', idKey: '' })
export class FacialRecognitionStore extends EntityStore<FacialRecognitionState> {

  constructor() {
    super();
  }

}
